import apiService, { buildQueryString } from './api';
class EquipamentosService {
    // Listar equipamentos
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/equipamentos${queryString}`);
        return response.data;
    }
    // Buscar equipamento por ID
    async getById(id) {
        const response = await apiService.get(`/equipamentos/${id}`);
        return response.data;
    }
    // Criar equipamento
    async create(data) {
        const response = await apiService.post('/equipamentos', data);
        return response.data;
    }
    // Atualizar equipamento
    async update(id, data) {
        const response = await apiService.put(`/equipamentos/${id}`, data);
        return response.data;
    }
    // Remover equipamento
    async delete(id) {
        await apiService.delete(`/equipamentos/${id}`);
    }
    // Gerar novo QR Code
    async generateQrCode(id) {
        const response = await apiService.post(`/equipamentos/${id}/qr-code`);
        return response.data;
    }
    // Buscar por QR Code
    async getByQrCode(qrCode) {
        const response = await apiService.get(`/equipamentos/qr/${qrCode}`);
        return response.data;
    }
    // Obter estatísticas
    async getStats() {
        const response = await apiService.get('/equipamentos/stats');
        return response.data;
    }
    // Buscar modelos
    async getModelos() {
        const response = await apiService.get('/modelos');
        return response.data;
    }
    // Buscar marcas
    async getMarcas() {
        const response = await apiService.get('/marcas');
        return response.data;
    }
    // Buscar tipos de equipamento
    async getTiposEquipamento() {
        const response = await apiService.get('/tipos-equipamento');
        return response.data;
    }
    // Criar tipo de equipamento
    async createTipoEquipamento(nome) {
        const response = await apiService.post('/tipos-equipamento', { nome });
        return response.data;
    }
    // Criar marca
    async createMarca(nome) {
        const response = await apiService.post('/marcas', { nome });
        return response.data;
    }
    // Criar modelo
    async createModelo(data) {
        const response = await apiService.post('/modelos', data);
        return response.data;
    }
    // Buscar modelos por marca e tipo
    async getModelosByMarcaAndTipo(marcaId, tipoEquipamentoId) {
        const filters = {};
        if (marcaId)
            filters.marcaId = marcaId;
        if (tipoEquipamentoId)
            filters.tipoEquipamentoId = tipoEquipamentoId;
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/modelos${queryString}`);
        return response.data;
    }
    // Upload de fotos
    async uploadFoto(file) {
        const formData = new FormData();
        formData.append('foto', file);
        const response = await apiService.upload('/equipamentos/upload-foto', formData);
        return response.data;
    }
    // Download de QR Code
    async downloadQrCode(equipamentoId, filename) {
        await apiService.download(`/equipamentos/${equipamentoId}/qr-code/download`, filename);
    }
    // Exportar equipamentos
    async exportar(format, filters = {}) {
        const queryString = buildQueryString({ ...filters, format });
        await apiService.download(`/equipamentos/export${queryString}`, `equipamentos.${format}`);
    }
    // Validar número de série
    async validateNumeroSerie(numeroSerie, equipamentoId) {
        const response = await apiService.post('/equipamentos/validate-numero-serie', {
            numeroSerie,
            equipamentoId
        });
        return response.data;
    }
    // Validar IMEI
    async validateIMEI(imei, equipamentoId) {
        const response = await apiService.post('/equipamentos/validate-imei', {
            imei,
            equipamentoId
        });
        return response.data;
    }
    // Buscar equipamentos de um cliente
    async getByCliente(clienteId) {
        const response = await apiService.get(`/equipamentos?clienteId=${clienteId}&limit=100`);
        return response.data.equipamentos;
    }
    // Buscar histórico de um equipamento
    async getHistorico(equipamentoId) {
        const response = await apiService.get(`/equipamentos/${equipamentoId}/historico`);
        return response.data;
    }
}
// Instância singleton
const equipamentosService = new EquipamentosService();
export default equipamentosService;
// Utilitários
export const estadosFisicos = [
    { value: 'EXCELENTE', label: 'Excelente', color: 'green' },
    { value: 'BOM', label: 'Bom', color: 'blue' },
    { value: 'USADO', label: 'Usado', color: 'yellow' },
    { value: 'DANIFICADO', label: 'Danificado', color: 'red' }
];
export const getEstadoFisicoConfig = (estado) => {
    return estadosFisicos.find(e => e.value === estado) || estadosFisicos[1];
};
export const formatEstadoFisico = (estado) => {
    const config = getEstadoFisicoConfig(estado);
    return config.label;
};
export const getEstadoFisicoColor = (estado) => {
    const config = getEstadoFisicoConfig(estado);
    return config.color;
};
